module.exports = __webpack_public_path__ + "static/img/gukesh.607845b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/gukesh.jpg
// module id = 475
// module chunks = 11